module.exports = __webpack_public_path__ + "img/p4-1-1.dc9495b7.png";